<template>
  <div class="main" v-if="userInfo">
    <div class="my-main">
      <!-- 头像模块 -->
      <div class="head-box">
        <div class="herd-left">
          <div class="head">
            <img
              v-if="userInfo.avatarUrl"
              :src="`${$Url}${userInfo.avatarUrl}`"
              @error="error"
            />
            <img v-else src="@/assets/image/module/head.png" />
          </div>

          <div class="name-box">
            <div class="name">{{ userInfo.name }}</div>

            <div class="grade-box">
              <div class="grade">
                <img
                  class="grade-name"
                  :src="require(`@/assets/image/homepage/v${this.grade}.png`)"
                />
                <span>等级</span>
              </div>
            </div>
          </div>
        </div>
        <img src="@/assets/image/hyperlink.png" class="share" />

        <div class="herd-right">
          <div class="head">
            <img
              v-if="userInfo.weChatUserInfo"
              :src="`${userInfo.weChatUserInfo.HeadImgUrl}`"
              @error="error"
            />
            <img v-else src="@/assets/image/module/head.png" />
          </div>

          <div class="name-box">
            <div class="name" v-if="userInfo.weChatUserInfo">
              {{ userInfo.weChatUserInfo.Nickname }}
            </div>

            <div class="grade-box">
              <div class="grade">
                <img
                  class="grade-name"
                  :src="require(`@/assets/image/homepage/v${this.grade}.png`)"
                />
                <span>等级</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 余额 -->
      <div class="balance-box">
        <div class="balance-item">
          <div class="number">{{ userInfo.balance }}<span>金币</span></div>
          <div class="tips">账户余额</div>
        </div>
        <div class="line"></div>
        <div class="balance-item">
          <div class="number">{{ userInfo.credit }}</div>
          <div class="tips">信用值</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getAccount,
  getWeChatAuthWechatUrl,
  getWeChatCallback,
} from "@/api/mobile";
import { generateUUID } from "@/utils/replace";
export default {
  data() {
    return {
      state: null,
      redirectUrl: null,
      grade: 1,
      userInfo: null,
    };
  },
  methods: {
    error(e) {
      console.log("111e", e);
      e.target.src = require("@/assets/image/module/head.png");
    },

    getGrade() {
      if (this.userInfo.credit <= 60) {
        return 1;
      }
      if (61 <= this.userInfo.credit && this.userInfo.credit <= 100) {
        return 2;
      }
      if (101 <= this.userInfo.credit && this.userInfo.credit <= 200) {
        return 3;
      }
      if (201 <= this.userInfo.credit && this.userInfo.credit <= 500) {
        return 4;
      }
      if (501 <= this.userInfo.credit && this.userInfo.credit <= 800) {
        return 5;
      }
      if (801 <= this.userInfo.credit && this.userInfo.credit <= 1000) {
        return 6;
      }
      return 1;
    },
  },
  async created() {
    //微信自动登录
    if (!localStorage.getItem("token")) {
      if (!this.$route.query.code) {
        let state = generateUUID();
        let redirectUrl = `https://www.aidajuan.com` + this.$route.path;
        await getWeChatAuthWechatUrl({
          redirectUrl,
          state,
        }).then((res) => {
          if (res.code === 200) {
            window.location.href = res.data;
          }
        });
        return;
      } else {
        await getWeChatCallback({
          code: this.$route.query.code,
          state: this.$route.query.state,
        }).then(async (res) => {
          if (res.code === 200) {
            localStorage.setItem("token", res.data.token);
            await getAccount().then((res) => {
              if (res.code === 200) {
                this.userInfo = res.data;
                localStorage.setItem("userInfo", JSON.stringify(res.data));
                this.$store.commit("changeUserInfo", this.userInfo);
                this.grade = this.getGrade();
              }
            });
          }
        });
      }
    }
    if (localStorage.getItem("token")) {
      await getAccount().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          localStorage.setItem("userInfo", JSON.stringify(res.data));
          this.$store.commit("changeUserInfo", this.userInfo);
          this.grade = this.getGrade();
        }
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  min-height: calc(100vh - 125px);
  background-color: #faf8ff;
  background-image: url("../../assets/mobile/image/common/shadow.png");
  background-size: cover;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 85px;
  padding-bottom: 40px;
  .my-main {
    min-height: 100vh;
    width: 100%;
    position: relative;
    z-index: 2;
    box-sizing: border-box;
    padding: 10px 15px 60px 15px;

    // 头像模块
    .head-box {
      margin-top: 17px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .herd-left {
        width: 50%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .head {
          width: 56px;
          height: 56px;
          border-radius: 28px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .name-box {
          display: flex;
          flex-direction: column;
          .name {
            color: #232323;
            font-size: 18px;
            font-weight: bolder;
            text-align: center;
            margin-top: 12px;
          }

          .grade-box {
            display: flex;
            margin-top: 5px;

            .grade {
              width: 55px;
              height: 22px;
              background: rgba(255, 162, 0, 0.1);
              border-radius: 11px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffa200;
              font-size: 12px;

              .grade-name {
                width: 16px;
                height: 16px;
                margin-right: 2px;
              }
            }

            .icon-grade {
              width: 23px;
              margin: 0 8px;
            }
          }
        }
      }
      .share {
        flex-shrink: 0;
        width: 50px;
        height: 50px;
      }

      .herd-right {
        width: 50%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .head {
          width: 56px;
          height: 56px;
          border-radius: 28px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .name-box {
          display: flex;
          flex-direction: column;
          .name {
            color: #232323;
            font-size: 18px;
            font-weight: bolder;
            text-align: center;
            margin-top: 12px;
          }

          .grade-box {
            display: flex;
            margin-top: 5px;

            .grade {
              width: 55px;
              height: 22px;
              background: rgba(255, 162, 0, 0.1);
              border-radius: 11px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffa200;
              font-size: 12px;

              .grade-name {
                width: 16px;
                height: 16px;
                margin-right: 2px;
              }
            }

            .icon-grade {
              width: 23px;
              margin: 0 8px;
            }
          }
        }
      }
    }

    //余额
    .balance-box {
      width: 100%;
      height: 77px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      display: flex;
      align-items: center;
      margin-top: 24px;

      .line {
        width: 1px;
        height: 41px;
        background: #ededed;
      }

      .balance-item {
        width: calc((100% - 1px) / 2);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;

        .number {
          color: #232323;
          font-size: 28px;
          font-weight: bolder;

          // margin-top: 14px;
          span {
            font-weight: normal;
            font-size: 12px;
            margin-left: 4px;
          }
        }

        .tips {
          color: #999999;
          font-size: 12px;
          // margin-top: 10px;
        }
      }
    }

    // 我的服务
    .service-box {
      padding: 17px 14px;
      box-sizing: border-box;
      width: 100%;
      background-color: #fff;
      border-radius: 8px;
      margin-top: 10px;

      .title {
        color: #232323;
        font-size: 16px;
        font-weight: bolder;
      }

      .card-box {
        display: flex;
        justify-content: space-between;

        .card-item {
          display: flex;
          flex-direction: column;
          color: #232323;
          flex-wrap: wrap;
          font-size: 12px;
          margin-top: 15px;

          .card-img {
            width: 48px;
            height: 48px;
            box-shadow: 0px 3px 12px 0px rgba(255, 151, 173, 0.349);
            margin-bottom: 11px;
            border-radius: 24px;
          }
        }

        .card-item0 {
          .card-img {
            background: linear-gradient(318deg, #ff6a88 0%, #ff8dca 100%);
            box-shadow: 0px 3px 12px 0px rgba(255, 151, 173, 0.349);
          }
        }

        .card-item1 {
          .card-img {
            background: linear-gradient(324deg, #6c93ff 0%, #40c3f4 100%);
            box-shadow: 0px 3px 12px 0px rgba(118, 175, 254, 0.4);
          }
        }

        .card-item2 {
          .card-img {
            background: linear-gradient(325deg, #ff512e 0%, #ff9a48 99%);
            box-shadow: 0px 3px 12px 0px rgba(255, 141, 73, 0.4);
          }
        }

        .card-item3 {
          .card-img {
            width: 48px;
            height: 48px;
            background: linear-gradient(150deg, #ffd21c 0%, #ff8112 100%);
            box-shadow: 0px 3px 12px 0px rgba(255, 206, 39, 0.349);
          }
        }
      }
    }

    // 我的邀请
    .invite-box {
      padding: 17px 14px;
      box-sizing: border-box;
      width: 100%;
      background-color: #fff;
      border-radius: 8px;
      margin-top: 10px;

      .invite-title {
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          color: #232323;
          font-size: 16px;
          font-weight: bolder;
        }

        .invite-right {
          display: flex;
          align-items: center;
          color: #999999;
          font-size: 14px;

          img {
            width: 14px;
            height: 14px;
            margin-left: 7px;
          }
        }
      }

      .invite-friend {
        width: 100%;
        background: rgba(255, 162, 0, 0.1);
        border-radius: 8px 8px 8px 8px;
        margin-top: 15px;
        box-sizing: border-box;
        padding: 20px 14px 15px 20px;

        .title {
          color: #cb630a;
          font-size: 16px;
          font-weight: bolder;
        }

        .invite-friend-bottom {
          display: flex;
          flex-wrap: wrap;
          color: #c78145;
          font-size: 14px;
          margin-top: 5px;
          justify-content: space-between;
          align-items: flex-end;

          .btn {
            width: 92px;
            height: 30px;
            background: linear-gradient(#ffa150 0%, #ffbb02 100%);
            border-radius: 15px;
            color: #fff;
            text-align: center;
            line-height: 30px;
          }
        }
      }

      .invite-number {
        display: flex;
        justify-content: space-between;
        margin-top: 11px;

        .invite-number-card {
          width: calc((100% - 10px) / 2);
          background: rgba(255, 162, 0, 0.1);
          height: 84px;
          border-radius: 8px;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;

          .invite-number-card-left {
            display: flex;
            flex-direction: column;
            justify-content: center;
            // align-items: center;
            height: 100%;
            font-size: 12px;
            color: #c78145;
            padding-left: 18px;
            // flex-shrink: 0;
            box-sizing: border-box;

            .name {
              color: #cb630a;
              font-size: 20px;
              font-weight: bolder;
              margin-bottom: 5px;
            }
          }

          img {
            width: 67px;
            height: 58px;
            flex-shrink: 0;
          }
        }
      }
    }

    // 其他服务
    .other-box {
      padding: 17px 14px;
      box-sizing: border-box;
      width: 100%;
      background-color: #fff;
      border-radius: 8px;
      margin-top: 10px;

      .title {
        color: #232323;
        font-size: 16px;
        font-weight: bolder;
      }

      .card-box {
        display: flex;
        flex-wrap: wrap;

        .card-item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          color: #232323;
          flex-wrap: wrap;
          font-size: 14px;
          margin-top: 25px;
          width: 25%;

          .card-img {
            width: 26px;
            height: 26px;
            margin-bottom: 13px;
          }
        }
      }
    }
  }
}
</style>